export const NEW_RESTRICTION = {
  Name: 'Новая специфика'
};
